import React from 'react';
import HoverZone from './HoverZone';

export default ({ willReceiveDraggable }) => {
  if (!willReceiveDraggable) return false;
  return (
    <div>
      <HoverZone key="up" direction="up" />
      <HoverZone key="down" direction="down" />
    </div>
  );
};
